import { Input as AntdInput } from 'antd';
import styled, { css } from 'styled-components';

import { createVar, sizeDown, sizeUp, vars } from '~/theme';
import ConfigurableModal from '~organisms/ConfigurableModal';
import DesignInformationBtn from '~organisms/DesignInformationBtn';

const _padding = createVar('_selectedShape-padding');

export const Container = styled.div({
  ...vars({
    [_padding]: sizeUp('10rem', ['md', '30rem']),
  }),

  paddingInline: _padding,

  position: 'relative',
});

export const ShapeOptions = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
});

export const InfoBtn = styled(DesignInformationBtn)({
  position: 'absolute',
  insetInlineEnd: _padding,
});

export const ShapeLabels = styled.div({
  display: 'flex',
  overflowX: 'auto',
  scrollbarWidth: 'thin',
  overflowY: 'hidden',
  gap: '20rem',

  height: '34rem',
});

export const LabelsDivider = styled.div(({ theme }) => ({
  width: '100%',
  height: '1rem',
  backgroundColor: theme.palette.silverFoil,
  marginBlock: '20rem',
}));

const shapeNameStyle = css(({ theme }) => ({
  flexShrink: 0,
  maxWidth: '200rem',
  width: '100%',
  height: '100%',
  backgroundColor: 'transparent',
  borderRadius: '5rem',
  border: `1rem solid ${theme.palette.gainsboro}`,
  paddingInlineStart: '16rem',

  textAlign: 'left',
  fontSize: theme.typography.size16,

  '&[data-is-active="true"]': {
    borderWidth: '2rem',
    borderColor: theme.palette.artichoke,

    color: theme.palette.artichoke,
  },
}));

export const Button = styled.button(
  () => shapeNameStyle,
  () => ({
    cursor: 'pointer',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    textWrap: 'nowrap',
  })
);

export const Input = styled(AntdInput)(() => shapeNameStyle);

export const AdjustDimensionsMsg = styled.span(({ theme }) => ({
  paddingBlockEnd: '20rem',

  color: theme.palette.red,
  fontSize: theme.typography.size14,
  fontFamily: theme.typography.family.arial,
}));

export const ShapeSideContainer = styled.div(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  margin: '40rem 0 0',

  fontFamily: theme.typography.family.arial,
}));

export const ShapeSideItem = styled(ShapeSideContainer)({
  inlineSize: sizeDown('100%', ['md', '50%']),
});

export const ModalImage = styled.img({
  marginTop: '20rem',
  maxHeight: '500rem',
});

export const SideItemOptions = styled.div(({ theme }) => ({
  marginLeft: '20rem',
  fontSize: theme.typography.size14,

  '& > div + div': {
    marginBlockStart: '15rem',
  },
}));

export const Modal = styled(ConfigurableModal)(({ theme }) => ({
  '.ant-modal-content': {
    background: `linear-gradient(180deg, ${theme.palette.graniteGray} 0%, ${theme.palette.black} 100%)`,
    fontSize: theme.typography.size16,
    color: theme.palette.white,

    svg: {
      color: theme.palette.white,
    },
  },
}));

export const SideTitle = styled.div(({ theme }) => ({
  fontSize: theme.typography.size18,
  minWidth: '12rem',
  textAlign: 'end',
}));
